/* eslint-disable react/jsx-no-useless-fragment */
import moment from "moment-timezone";
import {useTranslation} from "ni18n";
import React from "react";

import {SpecialtyId} from "../../constants/specialtyIds";
import {useGetSoonestInPracticeBySpecialtyId} from "../../hooks/useGetSoonestTime";
import {fakeTimestamp, isCI} from "../_common/_constants";
import {todayTomorrow4} from "../_common/Carbon";
import {LazyComp} from "../_common/LazyComp";

export const ReadableSlotTimeBySpecialtyId = ({
  specialtyId,
}: {
  specialtyId: SpecialtyId;
}): React.ReactElement => {
  const i18n = useTranslation();
  const maybeSlot = useGetSoonestInPracticeBySpecialtyId({
    specialtyId,
  });
  const nextApptSlotTime = todayTomorrow4(i18n.lang, maybeSlot?.time);

  if (isCI) {
    return <>{moment(fakeTimestamp).format("ddd, MMM Do")}</>;
  }

  return <LazyComp>{nextApptSlotTime}</LazyComp>;
};
